interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

interface Snapshot {
  canInstall: boolean;
  isInstalled: boolean;
}

let deferredEvent: BeforeInstallPromptEvent | null = null;
let snapshot: Snapshot = { canInstall: false, isInstalled: false };
const listeners = new Set<() => void>();

const setSnapshot = (next: Partial<Snapshot>) => {
  snapshot = { ...snapshot, ...next };
  listeners.forEach((listener) => listener());
};

// Registered at module scope (imported at the very top of main.tsx) so it is
// listening before React mounts anything. `beforeinstallprompt` fires once
// per page load as soon as Chrome finds the page installable — which can
// happen while the login screen is still up, well before any post-login
// component would exist to catch it. Missing that one firing loses it until
// the next full page load.
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredEvent = e as BeforeInstallPromptEvent;
  setSnapshot({ canInstall: true });
});

window.addEventListener('appinstalled', () => {
  deferredEvent = null;
  setSnapshot({ canInstall: false, isInstalled: true });
});

export const pwaInstallStore = {
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  getSnapshot() {
    return snapshot;
  },
  consumeDeferredEvent() {
    const event = deferredEvent;
    deferredEvent = null;
    setSnapshot({ canInstall: false });
    return event;
  },
};
